// ==== helpers/sendTo1C.js ====
import axios from 'axios';

const API_1C_ENDPOINT =
  window.location.protocol === 'https:'
    ? '/calc_porubki_2/1C_rubka/1c_proxy.php'
    : 'http://1c.profstal.net:30080//trade/hs/sale/calcrubki';

// единый axios-инстанс с увеличенным таймаутом
const api = axios.create({
  timeout: 30000, // было 15000
  headers: { 'Content-Type': 'application/json; charset=utf-8' },
});

/** Достаём doc из redirectUrl (приоритет) и из текущего location как запасной.
 *  Чиним кейс, когда doc «прилип» к code через второй "?".
 */
function getDocFromUrl(redirectUrl) {
  try {
    const extract = (urlObj) => {
      if (!urlObj) return null;
      // обычный doc
      let d = urlObj.searchParams.get('doc');
      if (d) return d;
      // doc, спрятанный внутри code=...?... (кривой URL)
      const code = urlObj.searchParams.get('code') || '';
      if (code.includes('?')) {
        const rest = code.split('?', 2)[1] || '';
        const sp = new URLSearchParams(rest);
        if (sp.has('doc')) return sp.get('doc');
      }
      return null;
    };

    // 1) из redirectUrl
    let d = extract(new URL(redirectUrl, window.location.origin));
    // 2) из текущей страницы — запасной путь
    if (!d) d = extract(new URL(window.location.href));
    return d || null;
  } catch {
    return null;
  }
}
// Временно прячем кнопки поворота, возвращаем функцию восстановления
function hideRotateButtons(root) {
  const hidden = [];
  root.querySelectorAll('.rotate-btn').forEach(el => {
    hidden.push([el, el.style.display]);
    el.style.display = 'none';
  });
  return () => hidden.forEach(([el, disp]) => (el.style.display = disp));
}

// Рисуем на время снимка штриховку, но кладём ЕЁ ПОД детали
function injectHatchLayer(container) {
    const hiddenStrips = [];
  container.querySelectorAll('.stripped').forEach(el => {
    hiddenStrips.push([el, el.style.display, el.style.opacity]);
    el.style.display = 'none';
    el.style.opacity = '0';
  });
  // отфильтруем только «настоящие» детали
  const isRealPart = (el) => {
    const cs = getComputedStyle(el);
    if (cs.position !== 'absolute') return false;
    if (el.classList?.contains('ps-hatch-snapshot')) return false;       // наш слой
    if ((cs.borderStyle || '').includes('dashed')) return false;          // рамки/линейки
    // прямоугольники — обычно с фоном
    const hasBg = cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)' && cs.backgroundColor !== 'transparent';
    // треугольники — ищем svg/polygon внутри
    const hasTriangle = !!el.querySelector?.('svg polygon');
    return hasBg || hasTriangle;
  };

  const parts = Array.from(container.children).filter(isRealPart);
  if (!parts.length) return () => hiddenStrips.forEach(([el, d, o]) => { el.style.display = d; el.style.opacity = o; });

  const lefts   = parts.map(el => el.offsetLeft);
  const rights  = parts.map(el => el.offsetLeft + el.offsetWidth);
  const tops    = parts.map(el => el.offsetTop);
  const bottoms = parts.map(el => el.offsetTop + el.offsetHeight);

  const minL = Math.min(...lefts);
  const maxR = Math.max(...rights);
  const minT = Math.min(...tops);
  const maxB = Math.max(...bottoms);
    const w = container.clientWidth  || 1;
  const h = container.clientHeight || 1;

  const leftPx   = Math.max(0, Math.round(minL));
  const topPx    = Math.max(0, Math.round(minT));
  const widthPx  = Math.max(1, Math.round(maxR - minL));
  const heightPx = Math.max(1, Math.round(maxB - minT));

  // создаём слой
  const hatch = document.createElement('div');
// вычисляем вертикальное положение «использованной» области
const topPct = Math.max(0, (minT / h) * 100);   // где minT — верхняя грань деталей в px
// heightPct у вас уже посчитан как ((maxB - minT) / h) * 100

  Object.assign(hatch.style, {
    position: 'absolute',
    top:    `${topPx}px`,
    left:   `${leftPx}px`,
    width:  `${widthPx}px`,
    height: `${heightPx}px`,
    backgroundImage: 'repeating-linear-gradient(-135deg, #b1b4d1 0 10px, #fff 10px 20px)',
    backgroundRepeat: 'repeat',
    backgroundPosition: '0 0',
    zIndex: '-1',
    pointerEvents: 'none',
  });
  hatch.className = 'ps-hatch-snapshot';

  // вставляем самым первым ребёнком, чтобы точно было под остальными
  container.insertBefore(hatch, container.firstChild);

    return () => {
    hatch.remove();
    hiddenStrips.forEach(([el, d, o]) => { el.style.display = d; el.style.opacity = o; });
  };
}


// компактный снимок: PNG с повышенным разрешением
async function makeSnapshotBase64(node, footerText) {
  if (!window.domtoimage) return null;

  const target =
    node ||
    document.querySelector('#root_2') ||
    document.querySelector('#root') ||
    document.querySelector('.my-calc') ||
    document.body;

  if (!target) return null;

      const hidden = [];
    target.querySelectorAll?.('.rotate-btn')?.forEach(el => {
      hidden.push([el, el.style.display]);
      el.style.display = 'none';
    });

  try {
        const unhideRotate = hideRotateButtons(target);
    const removeHatch  = injectHatchLayer(target);

    const rect = target.getBoundingClientRect();
    const DPR = Math.max(window.devicePixelRatio || 1, 1);
    const BASE = Math.max(2, DPR); // минимум 2x для чёткости
    const MAX_W = 2400;            // ограничим итоговую ширину, чтобы не упасть по памяти

    const targetW = Math.min(Math.round(rect.width * BASE), MAX_W);
    const scale   = targetW / Math.max(rect.width, 1);
    const targetH = Math.round(rect.height * scale);

    let dataUrl = await window.domtoimage.toPng(target, {
      width:  targetW,
      height: targetH,
      bgcolor: '#fff', // важное отличие: не трогаем backgroundImage контейнера
      style: {
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        boxShadow: 'none',
      },
      cacheBust: true,
    });

        // 1) Возвращаем видимость кнопок
        removeHatch();
    unhideRotate();

    // 2) Если нужна подпись (как в saveImages в App.js), дорисовываем текст снизу
    if (footerText) {
      const img = new Image();
      img.src = dataUrl;
      try { await img.decode(); } catch {}
      const canvas = document.createElement('canvas');
      canvas.width  = img.naturalWidth;
      canvas.height = img.naturalHeight + 50;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      ctx.fillStyle = '#000';
      ctx.font = '14px Arial';
      ctx.fillText(footerText, 10, img.naturalHeight + 30);
      dataUrl = canvas.toDataURL('image/png', 1.0);
    }

   // "data:image/png;base64,..." → только base64
    return dataUrl.split(',')[1];
  } catch (e) {
    console.warn('Не удалось сделать снимок листа:', e);
    return null;
  }
}

/**
 * Отправка "снимка" расчёта порубки в 1С
 * @param {string} redirectUrl
 * @param {HTMLElement} nodeToSnap
 * @param {object} extra
 */
export async function sendRedirectSnapshotTo1C(redirectUrl, nodeToSnap, extra = {}) {
  // 1) собрать все query-параметры
  const u = new URL(redirectUrl, window.location.origin);
  const queryObj = Object.fromEntries(u.searchParams.entries());
  if (extra?.totals?.lengthWithCut != null) {
  const len = Number(extra.totals.lengthWithCut);
  if (!Number.isNaN(len) && len >= 0) {
    u.searchParams.set('length', String(+len.toFixed(2)));  // в URL
    queryObj.length = String(+len.toFixed(2));              // в payload.data
  }
}

  // doc строго из URL (+чинится кривой code=...?...doc=...)
  const doc = getDocFromUrl(redirectUrl);
  if (doc && !queryObj.doc) {
    queryObj.doc = doc;            // в payload.data.doc
    u.searchParams.set('doc', doc); // и в самом redirectUrl (на всякий)
  }

    if (extra?.dynSheetW != null) {
    queryObj.dynSheetW = String(extra.dynSheetW);
  }

// 2) PNG-снимок + подпись (длина из поля «Метры» → мм)
const toNum = v => {
  const s = String(v ?? '').trim().replace(',', '.');
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : NaN;
};

const meters = toNum(extra?.totals?.lengthWithCut);
const lengthMmFromQty =
  Number.isFinite(meters) && meters > 0 ? Math.round(meters * 1000) : null;
const minSale = Number(extra?.minSale);
const sheetLenMm =
  Number(extra?.dynSheetW) || Number(extra?.product?.sheetWidth) || null;

let footerLenMm;
const usedLen = Number(extra?.footerLenMm); // Длина занятого пространства (шкала)

if (minSale !== 1) {
  // --- Продажа не целым листом ---
  if (usedLen > 0) {
    // Если есть уложенные детали, их длина в приоритете.
    footerLenMm = usedLen;
  } else {
    // Если деталей нет, берём динамическую ширину или ширину из кол-ва.
    footerLenMm = sheetLenMm || lengthMmFromQty;
  }
} else {
  // --- Продажа целым листом ---
  // Показываем полную длину листа.
  footerLenMm = sheetLenMm || usedLen || lengthMmFromQty;
}
const lengthText = `${footerLenMm} мм`;

const footerText = extra?.product
  ? `Толщина: ${extra.product.thickness} мм | Длина: ${lengthText} | Ширина: ${extra.product.sheetHeight} мм`
  : null;

  const nodes = Array.isArray(nodeToSnap) || nodeToSnap instanceof NodeList
    ? Array.from(nodeToSnap).filter(Boolean)
    : [nodeToSnap].filter(Boolean);

  const images = [];
  for (let i = 0; i < nodes.length; i++) {
    const base64 = await makeSnapshotBase64(nodes[i], footerText);
    if (base64) {
      images.push({ filename: `sheet_${Date.now()}_${i}.png`, mime: 'image/png', base64 });
    }
  }

  // ТЕПЕРЬ ВСЕГДА ОТПРАВЛЯЕМ МАССИВ (даже если картинка одна)
  const imagePayload = images.length > 0 ? images : null;

  // 3) payload
  const payload = {
    type: 'redirect',
    data: queryObj,
    meta: {
      ts: new Date().toISOString(),
      userAgent: navigator.userAgent,
      location: window.location.href,
      doc: queryObj.doc || null, // дублируем для удобного поиска в 1С
      ...extra,
    },
    image: imagePayload,
  };

  // 4) отправка с фолбэком: если таймаут — пробуем без картинки (легче)
  try {
    await api.post(API_1C_ENDPOINT, payload);
  } catch (err) {
      console.warn('Отправка в 1С не удалась:', {
    message: err?.message,
    status: err?.response?.status,
    data: err?.response?.data,
  });
    try {
      await api.post(API_1C_ENDPOINT, {
        ...payload,
        image: null,
        meta: { ...payload.meta, imageDropped: true },
      });
    } catch (err2) {
      console.warn('Повтор без изображения тоже не удался:', err2?.message || String(err2));
    }
  }
}
